"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var styles_1 = require("../../../styles");
exports.Content = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  max-width: ", ";\n  padding-bottom: 24px;\n  &:focus {\n    outline: 0;\n  }\n\n  label: Content;\n"], ["\n  background-color: ", ";\n  max-width: ", ";\n  padding-bottom: 24px;\n  &:focus {\n    outline: 0;\n  }\n\n  label: Content;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, styles_1.MAX_WIDTH.content);
var templateObject_1;
